import { LiveKitCall } from "@/components/LiveKitCall";
import { JitsiCall } from "@/components/JitsiCall";

/**
 * VideoCall — provider-agnostic wrapper.
 *
 * Dispatches to LiveKitCall or JitsiCall based on `providerId` (returned
 * by the backend `/video/token` endpoint). Prop contract is identical
 * across both so `ConsultationStage` and other consumers stay tidy:
 *
 *   <VideoCall
 *      providerId={livekit.providerId}
 *      roomName={...} displayName={...} email={...}
 *      jwt={livekit.token} domain={livekit.joinUrl}
 *      hipaaMode={livekit.hipaaMode}
 *      autoJoin onLeave={...} onApiReady={...}
 *   />
 *
 * `providerId` defaults to `"livekit"` when omitted so any legacy caller
 * that hasn't been migrated to the new hook still renders correctly.
 */
export function VideoCall({ providerId = "livekit", ...props }) {
  if (providerId === "jitsi") {
    return <JitsiCall {...props} />;
  }
  return <LiveKitCall {...props} />;
}
